import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUndo } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import CreatableSelect from "react-select/creatable";
import { Redirect, Link } from "react-router-dom";
import apiUrl from "./apiUrlConstant";
import Masters from "./masters/Masters";
import * as Yup from "yup";
import AuthService from "./AuthService";
import { Alert } from "react-bootstrap";
import CryptoJS from "crypto-js";

const key = CryptoJS.enc.Hex.parse("0123456789abcdef0123456789abcdef0123456789abcdef0123456789abcdef"); // 32 bytes hex
const iv = CryptoJS.enc.Hex.parse("abcdef9876543210abcdef9876543210"); // 16 bytes hex

const loginForm = Yup.object().shape({
  email: Yup.string().required("Required"),
  password: Yup.string().required("Required"),
});

class Login extends React.Component {
  state = {
    redirect: false,
    showLoader: false,
    errorMessage: "",
    showAlert: false,
    setShow: false,
  };

  constructor(props) {
    super(props);
  }
  componentDidMount(props) {
    var self = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/user/check-status`,
      data: { page: "login" },
    }).then(function (response) {
      console.log("user login status", response.data);
      if (response.data.result == "success") {
        self.setState({ redirect: true });
      }
    });
  }

  encrypt = (data) => {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
  
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64); // Only the ciphertext (no IV, no salt)
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;
      this.state.redirect = false;
      return <Redirect push to="/lease-summary" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <Formik
          validationSchema={loginForm}
          initialValues={{
            email: "",
            password: "",
          }}
          onSubmit={(values, actions, props) => {
            var ths = this;
            // ths.showLoader = true;
            this.setState({ showLoader: true });
            //localStorage.setItem("email", values.email);
            //localStorage.setItem("password", values.password);

            let encryptedPwd = this.encrypt(values.password);
            var self = this;

            values.password = encryptedPwd;

            axios({
              method: "post",
              url: `${apiUrl.apiUrl.url}/user/login`,
              data: values,
            }).then(function (response) {
              if (response.data.result == "error") {
                self.setState({
                  showLoader: false,
                  errorMessage: response.data.message,
                  showAlert: true,
                });
                // alert(response.data.message);
                actions.setSubmitting(false);
                actions.setErrors(response.data.message);
              } else {
                self.setState({ showLoader: false });
                //localStorage.setItem('currentUser', response.data.message);
                window.localStorage.setItem(
                  "user",
                  JSON.stringify(response.data.user)
                );
                window.localStorage.setItem("TOKEN", response.data.message);
                
                //window.location.pathname = "/lease-summary";
                window.location.pathname = "/"+response.data.user.dashboard;
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <div className="loginMainPage" style={{ backgroundImage: `url("/img/loginBackground.jpg")` }}>
              <Form  autoComplete="off" >
                <div className="text-center">
                  <Link to={`/`} className="">
                    <img src="/img/logo.png" className="logoImg" />
                  </Link>
                  <p className="tagLine text-center">
                    TAKE CONTROL OF YOUR REAL ESTATE
                  </p>
                  <Alert
                    variant="danger"
                    onClose={() => this.setState({ showAlert: false })}
                    dismissible
                    show={this.state.showAlert}
                  >
                    <Alert.Heading>
                      {this.state.errorMessage}
                    </Alert.Heading>
                  </Alert>
                </div>
                <div>
                  <div className="formInner mb-4">
                    <label >
                      Email <span>*</span>
                    </label>
                    <div className="position-relative">
                      <Field type="text" name="email" />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-red"
                      />
                    </div>
                  </div>
                  <div className="formInner mb-3">
                    <label>
                      Password <span>*</span>
                    </label>
                    <div className="position-relative">
                      <Field type="password" name="password" />
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-red"
                      />
                    </div>
                  </div>
                  <Link
                    to={`/user/forgot-password`}
                    className="btnLink"
                  >
                    Forgot Password?
                  </Link>
                  <div className="formInner">
                    {this.state.showLoader && (
                      <p
                        className="text-center mb-0"
                        style={{ fontWeight: "600" }}
                      >
                        <img src="/img/loading.gif" width={"80px"} />
                      </p>
                    )}
                    <button
                      type="submit"
                      className="loginBtn w-100"
                      value="LOGIN"
                      onClick={(e) => {
                        this.setState({ showAlert: false });
                      }}
                    >
                      LOGIN
                    </button>
                  </div>
                </div>
                <div className="madeByPart mt-5 text-center">
                  <p className="">Made By</p>
                  <p className="marginBottom-0">
                    <img src="/img/cre-matrix-logo.png" />
                  </p>
                </div>
              </Form>
            </div>
          )
          }
        </Formik>
      </div >
    );
  }
}

export default Login;
